'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HideLegendCheckbox = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HideLegendCheckbox = function HideLegendCheckbox(refs) {
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.Checkbox', {
        boxLabel: i18n.hide_legend,
        style: 'margin-bottom:' + _Style2.default.checkboxBottomMargin + 'px'
    });
};

exports.HideLegendCheckbox = HideLegendCheckbox;
exports.default = HideLegendCheckbox;
//# sourceMappingURL=HideLegend.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/HideLegend.js
 ** module id = 355
 ** module chunks = 0
 **/